import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './motoristaActions';

class MotoristaForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {
		
		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>								
							<Field
								name='id_transportadora'
								options={this.props.listaTransportadora}
								component={Select}
								label='Transportadora' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe'
								cols='12 5 5 5'
								readOnly={readOnly} />

							<Field
								name='codigo_integracao'
								component={LabelAndInput}
								label='Código de Integração' placeholder='Informe'
								cols='12 2 2 2'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='cpf'
								component={LabelAndInputMask}
								label='CPF *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={180}
								readOnly={readOnly}
								mask='999.999.999-99' />
													
							<Field
								name='rg'
								component={LabelAndInputNumber}
								label='RG *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={180}
								readOnly={readOnly}
								casas={0}
								semSeparadorMilhar />

							<Field
								name='cnh_numero'
								component={LabelAndInputNumber}
								label='CNH *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={180}
								readOnly={readOnly}
								casas={0}
								semSeparadorMilhar />

							<Field
								name='cnh_categoria'
								options={this.props.listaCnhCategoria}
								component={Select}
								label='Categoria *' placeholder='Informe'
								cols='12 12 7 7'
								readOnly={readOnly} />
						</Row>						
						<Row>
							<Field
								name='telegram'
								component={LabelAndInputMask}
								label='Telegram' placeholder='Informe'
								cols='12 4 3 2'
								readOnly={readOnly}
								mask='(99) 9 9999-9999' />
							
							<Field
								name='whatsapp'
								component={LabelAndInputMask}
								label='Whatsapp' placeholder='Informe'
								cols='12 4 3 2'
								readOnly={readOnly}
								mask='(99) 9 9999-9999' />
							
							<Field
								name='email'
								component={LabelAndInput}
								label='E-mail' placeholder='Informe'
								cols='12 4 4 3'
								readOnly={readOnly} />
						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }

}

MotoristaForm = reduxForm({form: 'motoristaForm', destroyOnUnmount: false})(MotoristaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('motoristaForm')(state),
	registro: state.motorista.registro,
	listaTransportadora: state.transportadora.listaSelect,
	listaCnhCategoria: state.motorista.listaCnhCategoria 
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MotoristaForm);
